"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Download extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onDownload", () => {
      const {
        dataset
      } = this.props;
      this.props.getResult(dataset.id).then(result => {
        if (result.data) {
          let jsonData = JSON.stringify(result.data);
          let blob = new Blob([jsonData], {
            type: result.mime_type || 'text/plain'
          });
          let download_link = document.createElement('a');
          download_link.download = result.file_name;
          download_link.href = window.URL.createObjectURL(blob);
          download_link.onClick = function (e) {
            let that = this;
            setTimeout(function () {
              window.URL.revokeObjectURL(that.href);
            }, 1500);
          };
          download_link.click();
          download_link.remove();
          let url = URL.createObjectURL(blob);
          document.getElementById('download_button').href = url;
          document.getElementById('download_button').download = result.file_name || "data.txt";
        }
      });
    });
  }
  render() {
    const {
      dataset
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card rounded shadow mb-3 p-5"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/_react.default.createElement("h4", {
      className: "card-title mb-4"
    }, dataset.title), /*#__PURE__*/_react.default.createElement("p", {
      className: "text-muted mb-5"
    }, dataset.description), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-text mt-5"
    }, dataset.fetching ? /*#__PURE__*/_react.default.createElement("button", {
      id: "download_button",
      onClick: this.onDownload,
      disabled: true,
      className: "btn btn-primary mr-5"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "spinner-border spinner-border-sm mr-2",
      role: "status",
      "aria-hidden": "true"
    }), "Gathering...") : /*#__PURE__*/_react.default.createElement("button", {
      id: "download_button",
      onClick: this.onDownload,
      className: "btn btn-primary mr-5"
    }, "Download"))));
  }
}
var _default = exports.default = Download;
module.exports = exports.default;